import React, { Component } from 'react';
import ethereum from 'decentralized/ethereum.js';
import { connect } from "react-redux";
import PulseLoader from 'react-spinners/PulseLoader'
import {
    setSelectedFolder,
    setFolderDragging,
    setPresetDragging,
    setHasChangesToFolders} from 'actions/index.js';
import ItemComponent from './ItemComponent.js';
import {  InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';

class FolderComponent extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            collapsed: true,
            nameValue: '',
            hovering: false,
            loading: false,
        };
    }

    async onClickCollapsed(e, collapsed) {
        e.stopPropagation();

        if (!collapsed) {
            // check if its dynamic and unloaded first
            if (this.props.folder.isDynamic() && !this.props.folder.isLoaded) {
                this.setState({loading: true});
                await this.props.folder.load();
                this.setState({loading: false});
            }
        }

        this.setState({
            collapsed: collapsed
        });

        this.onClickName();
    }

    getArrow() {
        if (this.state.collapsed) {
            return (
                <div
                  onClick={(e) => this.onClickCollapsed(e, false)}
                  className="collapse-button">
                  <div className="arrow-right">
                  </div>
                </div>);
        } else {
            return (
                <div
                  onClick={(e) => this.onClickCollapsed(e, true)}
                  className="collapse-button">
                  <div className="arrow-down"
                       onClick={(e) => this.onClickCollapsed(e, true)}>
                  </div>
                </div>);
        }
    }

    onDrop(e) {
        e.stopPropagation();
        this.setState({hovering: false});
        let folder = this.props.folderDragging;
        let preset = this.props.presetDragging;
        if (folder !== undefined) {
            this.props.setFolderDragging(undefined);
            if (this.props.folder === folder) {
                return;
            }
            folder.delete();
            this.props.folder.addFolder(folder);
        } else if (preset !== undefined) {
            preset.parent.deleteItem(preset);
            this.props.setPresetDragging(undefined);
            this.props.folder.addItem(preset);
        }
        this.props.onFoldersUpdated();
        this.props.setHasChangesToFolders(true);
    }

    onClickName() {
        let now = new Date().getTime();
        if (this.lastDate !== undefined && now - this.lastDate < 200) {
            // i.e. double click chooses the item
            this.props.onChooseFolder(this.props.folder);
        }
        this.lastDate = now;

        if (this.props.selectedFolder === this.props.folder) {
            this.props.setSelectedFolder(undefined);
        } else {
            this.props.setSelectedFolder(this.props.folder);
        }
    }

    onInputType(name) {
        this.setState({
            nameValue: name
        });
    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            this.props.folder.name = this.state.nameValue;
            this.setState(this.state);
        }
    }

    getNameComponent() {
        let folderNameClass =
            this.props.selectedFolder === this.props.folder && this.props.folder.name ?
            "folder-name selected" : "folder-name";

        if (this.state.hovering) {
            folderNameClass += ' hover';
        }

        return (
            <div
              draggable={true}
              onDragOver={(e) => this.onDragOver(e)}
              onDragStart={(e) => this.onDragStart(e)}
              onDragLeave={(e) => this.onDragLeave(e)}
              className={folderNameClass}>
                {this.getArrow()}
                <ConditionedComponent condition={this.props.folder.name}>
                  <div
                    className="name-label"
                    onClick={() => this.onClickName()}
                    >
                    {this.props.folder.name}
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.props.folder.name === undefined}>
                 <input
                  value={this.state.nameValue}
                  onChange={(event) => this.onInputType(event.target.value)}
                   onKeyDown={(event) => this.onKeyDown(event)}
                  ref={(input) => { this.input = input; }} 
                  placeholder="Type name of folder"
                  className="tag-input"/>
                </ConditionedComponent>
              </div>
        );
    }

    onDragOver(e) {
        e.preventDefault();
        this.setState({
            hovering: true});
    }

    onDragLeave(e) {
        this.setState({
            hovering: false
        });
    }

    onDragStart(e) {
        this.props.setFolderDragging(this.props.folder);
    }

    render() {
        let subFolders = [... this.props.folder.subFolders];
        subFolders.sort((a, b) => {
            if (a.name === undefined || b.name === undefined) {
                return 0;
            }
            return a.name.localeCompare(b.name);
        });
        let items = [...this.props.folder.items]
            .filter(i => i.name !== undefined);
        items.sort((a, b) => a.name.localeCompare(b.name));
        let depth = this.props.folder.depth <= 1 ? 0 : 1;
        let style = {
            paddingLeft: depth*17,
        };
        if (depth === 0) {
            depth = 1;
        }

        return (
            <div
              onDrop={(e) => this.onDrop(e)}
              className="folder" style={style}>
              {this.getNameComponent()}
             <ConditionedComponent condition={!this.state.collapsed}>
                {subFolders.map(
                    subFolder =>
                        <FolderComponent
                              key={subFolder.name}
                              {... this.props}
                              folder={subFolder}
                          />)}
              </ConditionedComponent>
              <PulseLoader
                loading={this.state.loading} 
                sizeUnit={"px"}
                size={10}
                color={'#123abc'}/>
              <ConditionedComponent condition={this.props.showItems && !this.state.collapsed}>
                {items.map(
                    item =>
                        <ItemComponent
                           key={item.name}
                           onChooseItem={this.props.onChooseItem}
                           onTestItem={this.props.onTestItem}
                           depth={depth}
                           item={item}
                        />)}
              </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedFolder: m => dispatch(setSelectedFolder(m)),
        setFolderDragging: m => dispatch(setFolderDragging(m)),
        setPresetDragging: m => dispatch(setPresetDragging(m)),
        setHasChangesToFolders: m => dispatch(setHasChangesToFolders(m)),
    };
};

const mapStateToProps = state => {
    return {
        selectedFolder: state.presets.selectedFolder,
        folderDragging: state.presets.folderDragging,
        presetDragging: state.presets.presetDragging,
        name: state.presets.selectedFolder !== undefined ? state.presets.selectedFolder.name : undefined,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(FolderComponent);

